<mat-card class="auth-block">
  <mat-card-content>
    <h1>404 - PAGE NOT FOUND</h1>
  </mat-card-content>
</mat-card>